import { Link } from 'react-router-dom';
import { Button, EmptyState } from '@vd/ui';
import { Compass, Lock, AlertOctagon } from 'lucide-react';

export function NotFoundPage() {
  return (
    <div style={{ minHeight: '70vh', display: 'grid', placeItems: 'center' }}>
      <EmptyState
        icon={<Compass size={28} />}
        title="This doesn't look familiar."
        description="The page you were looking for doesn't exist."
        action={<Link to="/"><Button variant="primary">Back to home</Button></Link>}
      />
    </div>
  );
}

export function ForbiddenPage() {
  return (
    <div style={{ minHeight: '70vh', display: 'grid', placeItems: 'center' }}>
      <EmptyState
        icon={<Lock size={28} />}
        title="You don't have access to this."
        description="Your company admin can grant access."
        action={<Button variant="primary">Request access</Button>}
      />
    </div>
  );
}

export function ServerErrorPage() {
  return (
    <div style={{ minHeight: '70vh', display: 'grid', placeItems: 'center' }}>
      <EmptyState
        icon={<AlertOctagon size={28} />}
        title="Something went wrong on our side."
        description="Incident ID: 0x0000. Our team has been notified."
      />
    </div>
  );
}
